import React from "react";
import './oNama.css';

const Content = () => {

    return(
        <div className="content">
            <div>
            <h3>Ustanova ,,Centar za obrazovanje odraslih" Bijeljina:</h3>
            <p className="tekst">
                Registrovana je u Okružnom privrednom sudu Bijeljina Rjesnjem
                broj 059-0-Reg - 11-000 613 od 09.09.2011. godine (na osnovu
                čega je dobila JIB 4403358200003 i matićni broj 11081908)
            </p>
            <p className="tekst">Dobila je odobrenje za izvodjenje programa formalnog obrazovanja
                odraslih za srednje stručno obrazovanje odraslih prekvalifikaciju i
                dokvalifikaciju za zanimanja: frizer(III stepen), kozmetičar(IV stepen)
                i trgovački tehnicar(IV stepen) i izvodjenje Programa osposobljavanja za 
                negovatelja starijih i nemoćnih lica Rješenjem Ministarstva prosvjete i kulture
                RS - Zavoda za obrazovanje odraslih 07/5.1/604-426/11 od 04.11.2011. godine kao i
                ekonomski tehničar (IV stepen), ugostiteljsko-kulinarski tehničar (IV stepen),
                tehničar drumskog saobraćaja (IV stepen), vozač motornih vozila (III stepen), i izvođenje
                sledecih programa osposobljavanja za poslove tesara, zidara, rukovaoca građevinskih mašina,
                zavarivača TIG postupkom, zavarivač MIG-MAG postupkom, molera, vodoinstalatera, armirača
                Rjesenjem Ministarstva prosvjete i kulture RS - Zavoda za obrazovanje 
                odraslih 07/5.1/604-379/12 od 11.12.2012. godine;
            </p>
            <p className="tekst">Otpočela je 1.02.2012. godine sa izvođenjem Programa osposobljavanja za negovatelja starijih lica,
                a 01.03.2012. godine sa srednjim stručnim obrazovanjem, prekvalifikacijom i dokvalifikacijom
                za zanimanja trećeg i četvrtog stepena.
            </p>
            </div>
        </div>
    );

}

export default Content